import { Button, Card } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

function handleLogin(instance) {
    instance.loginRedirect(loginRequest).catch(e => {
        console.error(e);
    });
}

const PublicPage = () => {
    const { instance } = useMsal();

    return (
        <>
            <h3 style={{ "text-align": "center" }}>Send a text quickly and discreetly in the event of a classroom emergency.</h3>
            <div class="row justify-content-center" style={{ marginTop: "50px" }}>
                <Card body style={{ width: "60%" }}>
                    <h5>How it works</h5>
                    <p>1. Add your emergency numbers to the app.</p>
                    <p>2. Tap Save.</p>
                    <p>3. Send a test text by tapping Send a Text</p>
                    <p>4. You're all set!</p>
                    <Button href="https://apps.apple.com/us/app/little-red-button/id1626397720">Try it out on the App Store</Button>
                    <br/>
                    <br/>
                    <Button href="https://play.google.com/store/apps/details?id=com.littleredapp2">Try it out on the Google Play Store</Button>
                </Card>
            </div>
            <div class="row justify-content-center" style={{ marginTop: "50px" }}>
                <Card body style={{ width: "60%" }}>
                    <h5>Pricing</h5>
                    <p>This app is completely free. If you'd like to support it by making a donation, you can click <a href="https://www.buymeacoffee.com/jevonshaw">here</a>.</p>
                </Card>
            </div>
            <div class="row justify-content-center" style={{ marginTop: "50px", marginBottom: "50px" }}>
                <Card body style={{ width: "60%" }}>
                    <h5>FAQ</h5>
                    <p><b>Do you collect any data?</b></p>
                    <p>The email addresses of your recipients is stored locally on your device. We do not have access to it.</p>
                    <p><b>Future plans?</b></p>
                    <p>We hope that soon users will be able to save up to 5 numbers and save customized text message templates.</p>
                    <p><b>I have some feedback. How can I communicate that to you?</b></p>
                    <p>Fill out the contact form <a href="https://forms.gle/Uk7BaJBeHrP58mWe8">here</a>.</p>

                </Card>
            </div>
            {/* <div class="row justify-content-center" style={{ marginTop: "50px" }}>
                <Card body style={{ width: "60%" }}>
                    <h5>More Apps</h5>
                    <p>If you'd like to be notified whenever future apps are released, submit your email address below.</p>
                </Card>
            </div> */}
        </>
    )
}

export default PublicPage;